import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* getHeroColor() {
  try {
    const res = yield call(api, {
      method: 'get',
      url: URL.HERO_COLOR,
    });
    yield put({ type: 'GET_HERO_COLOR_SUCCESS', payload: res.data });
  } catch (e) {
    yield put({ type: 'GET_HERO_COLOR_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_HERO_COLOR, getHeroColor);
}
